<template>
    <div class="aia-header">
        <div class="aia-back"
            @click="clickBack">
            <img class="img-fluid" src="@/assets/icon/ic-back@3x.png" />
        </div>
        <div id="mass_logo" class="aia-logo">
            <img class="img-fluid img-sharpen" src="../../../../assets/logo/mass/logo-aia.png" />
        </div>
        <div class="aia-search"
            @click="clickSearch()">
            <img src="../../../../assets/icon/ic_search.svg" />
        </div>
    </div>
</template>
<script>
export default {
    name: 'MassHeader',
    methods: {
        //event
        clickBack: function () {
            this.$emit('clickBack');
        },
        clickSearch: function () {
            this.$router.push('/search');
        }
    }
}
</script>
<style lang="scss" scoped>
@import "../AIAHeader.scss";
.aia-header {
    background-color: $mass_theme_color;

    #mass_logo {
        width: 50px;
    }
}
</style>
